import AllDonePage from './all-done-page';

export default AllDonePage;
